export function Footer() {
  const version = "2026.11.05";
  
  return (
    <footer className="fixed bottom-0 w-full bg-background/95 backdrop-blur-sm supports-backdrop-filter:bg-background/60 border-t">
      <div className="container flex h-14 items-center justify-between">
        <p className="mx-6 text-sm text-muted-foreground">
          Skillhub [{version}]
        </p>
      </div>
    </footer>
  );
}
